(function() { window.GUID_6bbbb666_abdd_4ab0_8dcc_e64523cc284e = { getGuid: function() { return "6bbbb666-abdd-4ab0-8dcc-e64523cc284e"; } }; })();
var RejectedReason;
(function (RejectedReason) {
    var desktop;
    (function (desktop) {
        let gridViewPendingScoreSheetsUI = $('#GridViewPendingScoreSheets');
        let gridViewPendingScoreSheets = gridViewPendingScoreSheetsUI.data('context');
        let gridViewSchedulesUI = $('#GridViewSchedules');
        let gridViewSchedules = gridViewSchedulesUI.data('context');
        CS.body.on('Refreshed', '#GridViewSchedules', function (e, gridView) {
            gridViewSchedules = gridView;
        });
        CS.body.on('Refreshed', '#GridViewPendingScoreSheets', function (e, gridView) {
            gridViewPendingScoreSheets = gridView;
        });
        CS.FormReady(function (formId) {
            if (formId == "RejectedReason") {
                var rejectedReason = $('#rejectedReason');
                //Ici, j'évite que la touche Enter post le formulaire
                rejectedReason.on('keypress', function (e) {
                    e.stopPropagation();
                });
            }
        });
        function RejectedReasonPopup(formDialog) {
            var encounterRowId = $('#encounterRowId').val();
            formDialog.dialog("close");
            var ElementToRefreshName = $('#elementToRefresh').val();
            var ElementToRefresh = null;
            if (ElementToRefreshName == 'GridViewPendingScoreSheets') {
                ElementToRefresh = gridViewPendingScoreSheets;
            }
            else {
                ElementToRefresh = gridViewSchedules;
            }
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "RejectedReasonPopup",
                Url: CSParameters.RUrl + 'Scores/ScorePopupRejected/' + CSParameters.SportEventId + '?encounterRowId=' + encounterRowId + '&elementToRefresh=' + ElementToRefreshName,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            ElementToRefresh.RefreshGridData();
            /*
            ShowFormPopup(CSParameters.RUrl + 'Scores/ScorePopupRejected/' + CSParameters.SportEventId + '?encounterRowId=' + encounterRowId + '&elementToRefresh=' + ElementToRefreshName, null, ElementToRefresh, function () {
    
                $(this).dialog("close");
            });
            */
        }
    })(desktop = RejectedReason.desktop || (RejectedReason.desktop = {}));
})(RejectedReason || (RejectedReason = {}));

//# sourceMappingURL=RejectedReason.desktop.js.map
